import { faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";
import { Pre_demo_img, foodIcon } from "../../../assets/images";
import "./restaurantcategory.css";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import axiosInstance from "../../../services/axios.instance";
import { API_URL } from "../../../services/apiConfig";
import { useLocation, useNavigate } from "react-router-dom";
import Carousel from "react-multi-carousel";
import { sendEventToServer } from "../../../hooks/sendEventToServer";

const groupByShop = (products: any) => {
  return products.reduce((acc: any, product: any) => {
    const { shopName } = product._source;
    if (!acc[shopName]) {
      acc[shopName] = [];
    }
    acc[shopName].push(product._source);
    return acc;
  }, {});
};

const RestaurantCategory = () => {
  const navigate = useNavigate();
  const location = useSelector(
    (state: { products: { location: any } }) => state.products.location
  );
  const categoryMeatMerchant = useSelector(
    (state: any) => state?.merchant?.selectedMeatMerchantId
  );
  const { customerId } = useSelector((state: any) => state.auth);

  const [groceryProducts, setGroceryProducts] = useState<any[]>([]);
  const locations = useLocation();
  const pathSegments = locations.pathname.split("/");
  const routeName = pathSegments[1] || "Unknown";
  const {
    id: ID,
    name: Name,
    parent_category: parent_category,
    subcategories: Subcategories,
    merchantId,
  } = locations.state || {};

  const planet = routeName
    ? routeName === "FoodCategory"
      ? "foodPlanet"
      : routeName === "GroceryCategory"
      ? "groceryPlanet"
      : routeName === "FishCategory"
      ? "fishPlanet"
      : routeName === "MeatCategory"
      ? "meatPlanet"
      : routeName === "OrganicCategory"
      ? "fruitVegPlanet"
      : null
    : null;

  const { data: response } = useQuery({
    queryFn: () => {
      if (planet === "fishPlanet") {
        return axiosInstance.post(API_URL.GROCERRY_PRODUCT_LIST, {
          index: "0",
          count: "500",
          country: "ALL",
          business_area: "fishPlanet",
          latitude: location?.latitude,
          longitude: location?.longitude,
          category_id: ID,
          customer_id: customerId,
          merchant_id: merchantId,
          is_parent_category: true,
        });
      } else if (planet === "meatPlanet") {
        return axiosInstance.post(API_URL.GROCERRY_PRODUCT_LIST, {
          index: "0",
          count: "500",
          country: "ALL",
          business_area: "meatPlanet",
          latitude: location?.latitude,
          longitude: location?.longitude,
          category_id: ID,
          customer_id: customerId,
          merchant_id: categoryMeatMerchant,
          is_parent_category: true,
        });
      } else if (planet === "fruitVegPlanet") {
        return axiosInstance.post(API_URL.GROCERRY_PRODUCT_LIST, {
          index: "0",
          count: "500",
          country: "ALL",
          business_area: "fruitVegPlanet",
          latitude: location?.latitude,
          longitude: location?.longitude,
          category_id: ID,
          customer_id: customerId,
          merchant_id: categoryMeatMerchant,
          is_parent_category: true,
        });
      } else {
        return axiosInstance.post(
          API_URL.FOOD_LISTING,
          {
            name: Name,
            latitude: location?.latitude,
            longitude: location?.longitude,
            res: 6,
            planet_id: planet,
          },
          {
            headers: { version: "v4" },
          }
        );
      }
    },
    queryKey: [
      planet === "foodPlanet" ? "getCategories" : "getFishCategories",
      location.latitude,
      location.longitude,
      planet,
    ],
    enabled: !!location?.latitude || !!location?.longitude,
    onSuccess: (data) => {
      const eventName =
        planet === "fishPlanet"
          ? "CONSUMER_WEB_FISH_CATEGORY_PRODUCTS"
          : planet === "meatPlanet"
          ? "CONSUMER_WEB_MEAT_CATEGORY_PRODUCTS"
          : planet === "fruitVegPlanet"
          ? "CONSUMER_WEB_FRUITVEG_CATEGORY_PRODUCTS"
          : "";

      sendEventToServer({
        NAME: eventName,
        CUSTOMER_ID: customerId,
        MODULE: "CART",
        PAYLOAD: { product: data },
        EVENT_CATEGORY: "INFO",
        MERCHANT_ID: merchantId,
      });
    },
    onError: (error) => {
      console.error("Error fetching data:", error);
    },
  });

  const handleImageClick = async (subcategory: any) => {
    try {
      const { data } = await axiosInstance.post(
        API_URL.GROCERRY_PRODUCT_LIST,
        JSON.stringify({
          index: "0",
          count: "500",
          country: "ALL",
          business_area: planet,
          category_id: subcategory?.category_id,
          is_parent_category: false,
          merchant_id: merchantId,
        })
      );

      setGroceryProducts(data.content);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const foodlisting = response?.data?.hits?.hits || [];
  const fishListing = response?.data?.content || [];
  const groupedProducts = groupByShop(foodlisting);

  const handleProductClick = (productId: string) => {
    const navigateToDetails =
      planet === "foodPlanet"
        ? `/FoodDetails?id=${productId}`
        : planet === "fishPlanet" || "meatPlanet"
        ? `/ProductDetails?Planet=${planet}&id=${productId}`
        : `/GroceryDetails?id=${productId}`;

    navigate(navigateToDetails, {
      state: { productId, planetId: planet },
    });
  };

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 5,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
    },
  };

  const convertWeightToKg = (weight: any) => {
    return Number(weight) >= 1000 ? `${weight / 1000}Kg` : `${weight}g`;
  };

  return (
    <div className="col-12 d-flex justify-content-center text-start pb-4 pt-5">
      <div className="row width-full-page-product pb-5 relative-div-bg">
        <div className="inner-text-heading">
          <span className="span-with-green">
            {planet === "foodPlanet"
              ? "Restaurants & Dishes"
              : planet === "fishPlanet"
              ? "Fish & Seafood"
              : "Products"}
          </span>
        </div>

        {/* Subcategories Section */}
        {planet !== "fishPlanet" &&
          planet !== "meatPlanet" &&
          Subcategories &&
          Subcategories.length > 0 && (
            <div className="subcategories-section pt-4 div-caroysel-relative">
              <Carousel responsive={responsive} swipeable={true}>
                {Subcategories.map((subcategory: any) => (
                  <div
                    key={subcategory.id}
                    className="p-2 width-in-pixel content-fishcard"
                    onClick={() => handleImageClick(subcategory)}
                  >
                    <Card className="card-hghlght card-no-border product-card-cat">
                      <CardBody>
                        <img
                          src={subcategory?.background_image || foodIcon}
                          alt={subcategory?.name}
                          className="img-ratio-card"
                        />
                        <div className="pt-2">
                          <div className="inner-text-heading-two">
                            {subcategory?.name}
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </div>
                ))}
              </Carousel>
            </div>
          )}

        <div className="row pt-3">
          {groupedProducts && planet === "foodPlanet"
            ? Object.keys(groupedProducts).map((shopName) => (
                <div className="col-md-4">
                  <Card key={shopName} className="restaurant-category-div mb-4">
                    <CardBody>
                      <div className="bottom-border">
                        <div className="sub-div-headings">{shopName}</div>
                      </div>
                      <div className="d-flex width-main-div-product pt-3 pb-3">
                        {groupedProducts[shopName].map((product: any) => (
                          <div
                            key={product?.productId}
                            className="p-2 width-in-pixel content-fishcard"
                          >
                            <Card className="card-hghlght card-no-border product-card-cat">
                              <CardBody>
                                <img
                                  src={product?.productImages?.[0] || foodIcon}
                                  alt={product?.name}
                                  className="img-ratio-card"
                                />
                                <div className="pt-2">
                                  <div className="inner-text-heading-two">
                                    {product?.name}
                                  </div>
                                  <div className="inner-text-content-three">
                                    Price:{" "}
                                    <span className="inner-text-heading-four">
                                      {product?.price} rs
                                    </span>
                                  </div>
                                  <div className="inner-text-content-four">
                                    <FontAwesomeIcon
                                      icon={faStar}
                                      className="yellow-star"
                                    />
                                    &nbsp; {product.rating} (
                                    {product?.totalReviews} reviews)
                                  </div>
                                  <div className="pt-2 custom-button-div text-end">
                                    <button
                                      className=" add-to-cart-button"
                                      onClick={() =>
                                        handleProductClick(product?.productId)
                                      }
                                    >
                                      View
                                    </button>
                                  </div>
                                </div>
                              </CardBody>
                            </Card>
                          </div>
                        ))}
                      </div>
                    </CardBody>
                  </Card>
                </div>
              ))
            : groceryProducts
            ? groceryProducts?.map((product: any) => (
                <div
                  key={product?.product_id}
                  className="col-md-4 p-2 width-in-pixel content-fishcard"
                >
                  <Card className="card-hghlght card-no-border product-card-cat">
                    <CardBody>
                      <img
                        src={product?.product_details.images[0] || foodIcon}
                        alt={product?.product_name}
                        className="img-ratio-card"
                      />
                      <div className="pt-2">
                        <div className="inner-text-heading-two">
                          {product?.product_name}
                        </div>
                        <div className="inner-text-content-three">
                          Price:{" "}
                          <span className="inner-text-heading-four">
                            {product?.price} rs
                          </span>
                        </div>
                        <div className="inner-text-content-four">
                          <FontAwesomeIcon
                            icon={faStar}
                            className="yellow-star"
                          />
                          &nbsp; {product?.rating} ({product?.total_reviews}{" "}
                          reviews)
                        </div>
                        <div className="pt-2 custom-button-div text-end">
                          <button
                            className=" add-to-cart-button"
                            onClick={() =>
                              handleProductClick(product?.product_id)
                            }
                          >
                            View
                          </button>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              ))
            : null}
          {(planet === "fishPlanet" || planet === "meatPlanet") &&
            (fishListing.length > 0 ? (
              fishListing.map((product: any) => (
                <div
                  key={product?.product_id}
                  className="col-lg-3 col-md-4 col-6 p-2 width-in-pixel content-fishcard"
                >
                  <Card className="stock-card card-hghlght-reverse product-card-cat">
                    <CardBody>
                      <div className="card-img-div-top">
                        <img
                          className={`card-img-top `}
                          src={
                            product?.product_details?.images?.[0] ||
                            Pre_demo_img
                          }
                          alt={product?.product_name}
                        />
                      </div>
                      <div className="text-div-card">
                        <div className="card-inner-text-div">
                          <div className="inner-text-heading-four text-one-line">
                            {product?.product_name}
                          </div>
                          <div className="inner-text-content-five-font-12">
                            <div className="">{product?.category_name}</div>

                            <div className="d-flex">
                              <div className="">
                                <span className="font-color-gray">
                                  {convertWeightToKg(product.weight)}&nbsp;net
                                </span>
                              </div>
                              <div
                                className=" inner-text-content-five-font- font-color-gray text-end text-nowrap"
                                style={{ width: "100%" }}
                              >
                                <FontAwesomeIcon
                                  icon={faStar}
                                  className="yellow-star"
                                />
                                &nbsp; {product?.rating} (
                                {product?.total_reviews} reviews)
                              </div>
                            </div>
                          </div>
                          <div className="col inner-text-content-three text-start">
                            Price:{" "}
                            <span className="inner-text-heading-four">
                              ₹ {product?.price}
                            </span>
                          </div>
                        </div>
                        <div className="pt-2 custom-button-div text-end">
                          <button
                            className=" add-to-cart-button"
                            onClick={() =>
                              handleProductClick(product?.product_id)
                            }
                          >
                            View
                          </button>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              ))
            ) : (
              <div className="col-12 text-center">
                <p className="no-products-message">
                  No products available for this category
                </p>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default RestaurantCategory;
